/* eslint-disable */
import { Link, useLocation } from "react-router-dom";
import ImageWithBasePath from "../../imageWithBasePath";
import Breadcrumb from "../breadcrumb/breadcrumb"; // Adjust the path as needed
import { breadcrumbMap } from "../breadcrumb/breadcrumbData";
import { useEffect } from "react";
import { updateTheme } from "../../redux/themeSlice";
import { useDispatch, useSelector } from "react-redux";
import { all_routes } from "../../../feature-module/router/all_routes";
import { setMobileSidebar } from "../../redux/sidebarSlice";


const Header = () => {
  const location = useLocation();
  const path = location.pathname;
  // fallback to empty array or default breadcrumb
  const breadcrumbItems = breadcrumbMap[path] || [
    { label: "Home", path: "/", active: false },
    { label: "Unknown Page", active: true },
  ];
  const dispatch = useDispatch();
  const themeSettings = useSelector((state: any) => state.theme.themeSettings);




  useEffect(() => {
    const htmlElement: any = document.documentElement;
    Object.entries(themeSettings).forEach(([key, value]) => {
      htmlElement.setAttribute(key, value);
    });
  }, [themeSettings]);




  const handleUpdateTheme = (key: string, value: string) => {
    if (themeSettings["dir"] === "rtl" && key !== "dir") {
      dispatch(updateTheme({ dir: "ltr" }));
    }
    dispatch(updateTheme({ [key]: value }));
  };

  const mobileSidebar = useSelector(
    (state: any) => state.sidebarSlice.mobileSidebar
  );

  const toggleMobileSidebar = () => {
    dispatch(setMobileSidebar(!mobileSidebar));
  };



  return (
    <>
      {/* Topbar Start */}
      <div className="header">
        <div className="main-header">
          {/* Logo */}
          <div className="header-left">
            <Link to={all_routes.adminDashboard} className="logo">
              <ImageWithBasePath src="assets/img/logo.svg" alt="Logo" />
            </Link>
            <Link to={all_routes.adminDashboard} className="dark-logo">
              <ImageWithBasePath src="assets/img/logo-white.svg" alt="Logo" />
            </Link>
          </div>
          {/* Sidebar Menu Toggle Button */}
          <Link id="mobile_btn" className="mobile_btn" to="#sidebar" onClick={toggleMobileSidebar} >
            <span className="bar-icon">
              <span />
              <span />
              <span />
            </span>
          </Link>
          <div className="header-user">
            <div className="nav user-menu nav-list">
              <div
                className="me-auto d-flex align-items-center"
                id="header-search"
              >
                {/* Add */}
                <div className="dropdown me-3">
                  <Link
                    className="btn btn-primary bg-gradient btn-xs btn-icon rounded-circle d-flex align-items-center justify-content-center"
                    data-bs-toggle="dropdown"
                    to="#"
                    role="button"
                  >
                    <i className="isax isax-add text-white" />
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-start p-2">
                    <li>
                      <Link
                        to={all_routes.addInvoice}
                        className="dropdown-item d-flex align-items-center"
                      >
                        <i className="isax isax-document-text-1 me-2" />
                        Invoice
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={all_routes.expenses}
                        className="dropdown-item d-flex align-items-center"
                      >
                        <i className="isax isax-money-send me-2" />
                        Expense
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={all_routes.addCreditNotes}
                        className="dropdown-item d-flex align-items-center"
                      >
                        <i className="isax isax-money-add me-2" />
                        Credit Notes
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={all_routes.addDebitNotes}
                        className="dropdown-item d-flex align-items-center"
                      >
                        <i className="isax isax-money-recive me-2" />
                        Debit Notes
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={all_routes.addPurchaseOrders}
                        className="dropdown-item d-flex align-items-center"
                      >
                        <i className="isax isax-document me-2" />
                        Purchase Order
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={all_routes.addquotations}
                        className="dropdown-item d-flex align-items-center"
                      >
                        <i className="isax isax-document-download me-2" />
                        Quotation
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={all_routes.addDeliveryChallans}
                        className="dropdown-item d-flex align-items-center"
                      >
                        <i className="isax isax-document-forward me-2" />
                        Delivery Challan
                      </Link>
                    </li>
                  </ul>
                </div>
                {/* Breadcrumb */}
                <Breadcrumb items={breadcrumbItems} />
              </div>
              <div className="d-flex align-items-center">
                {/* Search */}
                <div className="input-icon-end position-relative me-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                  />
                  <span className="input-icon-addon">
                    <i className="isax isax-search-normal" />
                  </span>
                </div>
                {/* /Search */}
                {/* Language Dropdown */}
                <div className="nav-item dropdown has-arrow flag-nav me-2">
                  <Link
                    className="btn btn-menubar"
                    data-bs-toggle="dropdown"
                    to="#"
                    role="button"
                  >
                    <ImageWithBasePath
                      src="assets/img/flags/us.svg"
                      alt="Language"
                      className="img-fluid"
                    />
                  </Link>
                  <ul className="dropdown-menu p-2">
                    {/* item*/}
                    <li>
                      <Link to="#" className="dropdown-item">
                        <ImageWithBasePath
                          src="assets/img/flags/us.svg"
                          alt="flag"
                          className="me-2"
                        />
                        English
                      </Link>
                    </li>
                    {/* item*/}
                    <li>
                      <Link to="#" className="dropdown-item">
                        <ImageWithBasePath
                          src="assets/img/flags/de.svg"
                          alt="flag"
                          className="me-2"
                        />
                        German
                      </Link>
                    </li>
                    {/* item*/}
                    <li>
                      <Link to="#" className="dropdown-item">
                        <ImageWithBasePath
                          src="assets/img/flags/fr.svg"
                          alt="flag"
                          className="me-2"
                        />
                        French
                      </Link>
                    </li>
                    {/* item*/}
                    <li>
                      <Link to="#" className="dropdown-item">
                        <ImageWithBasePath
                          src="assets/img/flags/ae.svg"
                          alt="flag"
                          className="me-2"
                        />
                        Arabic
                      </Link>
                    </li>
                  </ul>
                </div>
                {/* Notification */}
                <div className="notification_item me-2">
                  <Link
                    to="#"
                    className="btn btn-menubar position-relative"
                    id="notification_popup"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="isax isax-notification-bing5" />
                    <span className="position-absolute badge bg-success border border-white" />
                  </Link>
                  <div
                    className="dropdown-menu p-0 dropdown-menu-end dropdown-menu-lg"
                    style={{ minHeight: 300 }}
                  >
                    <div className="p-2 border-bottom">
                      <div className="row align-items-center">
                        <div className="col">
                          <h6 className="m-0 fs-16 fw-semibold">
                            {" "}
                            Notifications
                          </h6>
                        </div>
                        <div className="col-auto">
                          <div className="dropdown">
                            <Link
                              to="#"
                              className="dropdown-toggle drop-arrow-none link-dark"
                              data-bs-toggle="dropdown"
                              data-bs-offset="0,15"
                              aria-expanded="false"
                            >
                              <i className="isax isax-setting-2 fs-16 text-body align-middle" />
                            </Link>
                            <div className="dropdown-menu dropdown-menu-end">
                              {/* item*/}
                              <Link to="#" className="dropdown-item">
                                <i className="ti ti-bell-check me-1" />
                                Mark as Read
                              </Link>
                              {/* item*/}
                              <Link to="#" className="dropdown-item">
                                <i className="ti ti-trash me-1" />
                                Delete All
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Notification Dropdown */}
                    <div
                      className="notification-body position-relative z-2 rounded-0"
                      data-simplebar=""
                    >
                      {/* Item*/}
                      <div
                        className="dropdown-item notification-item py-2 text-wrap border-bottom"
                        id="notification-1"
                      >
                        <div className="d-flex">
                          <div className="me-2 position-relative flex-shrink-0">
                            <ImageWithBasePath
                              src="assets/img/profiles/avatar-05.jpg"
                              className="avatar-md rounded-circle"
                              alt=""
                            />
                          </div>
                          <div className="flex-grow-1">
                            <p className="mb-0 fw-semibold text-dark">
                              John Smith
                            </p>
                            <p className="mb-1 text-wrap fs-14">
                              A <span className="fw-semibold">new sale</span>{" "}
                              has been recorded.
                            </p>
                            <div className="d-flex justify-content-between align-items-center">
                              <span className="fs-12">
                                <i className="isax isax-clock me-1" />4 min ago
                              </span>
                              <div className="notification-action d-flex align-items-center float-end gap-2">
                                <Link
                                  to="#"
                                  className="notification-read rounded-circle bg-info"
                                  data-bs-toggle="tooltip"
                                  title=""
                                  data-bs-original-title="Make as Read"
                                  aria-label="Make as Read"
                                />
                                <button
                                  className="btn rounded-circle text-danger p-0"
                                  data-dismissible="#notification-1"
                                >
                                  <i className="isax isax-close-circle fs-12" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Item*/}
                      <div
                        className="dropdown-item notification-item py-2 text-wrap border-bottom"
                        id="notification-2"
                      >
                        <div className="d-flex">
                          <div className="flex-shrink-0">
                            <div className="avatar-sm me-2">
                              <span className="avatar-title bg-soft-info text-info fs-18 rounded-circle">
                                D
                              </span>
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <p className="mb-0 fw-semibold text-dark">
                              Donoghue Susan
                            </p>
                            <p className="mb-0 text-wrap fs-14">
                              Switched to a lower-tier package
                            </p>
                            <div className="d-flex justify-content-between align-items-center">
                              <span className="fs-12">
                                <i className="isax isax-clock me-1" />4 min ago
                              </span>
                              <div className="notification-action d-flex align-items-center float-end gap-2">
                                <Link
                                  to="#"
                                  className="notification-read rounded-circle bg-info"
                                  data-bs-toggle="tooltip"
                                  title=""
                                  data-bs-original-title="Make as Read"
                                  aria-label="Make as Read"
                                />
                                <button
                                  className="btn rounded-circle text-danger p-0"
                                  data-dismissible="#notification-2"
                                >
                                  <i className="isax isax-close-circle fs-12" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Item*/}
                      <div
                        className="dropdown-item notification-item py-2 text-wrap border-bottom"
                        id="notification-3"
                      >
                        <div className="d-flex">
                          <div className="me-2 position-relative flex-shrink-0">
                            <ImageWithBasePath
                              src="assets/img/profiles/avatar-03.jpg"
                              className="avatar-md rounded-circle"
                              alt=""
                            />
                          </div>
                          <div className="flex-grow-1">
                            <p className="mb-0 fw-semibold text-dark">
                              Robert Fox{" "}
                            </p>
                            <p className="mb-1 text-wrap fs-14">
                              Completed payment for{" "}
                              <span className="fw-semibold">#INV00025</span>
                            </p>
                            <div className="d-flex justify-content-between align-items-center">
                              <span className="fs-12">
                                <i className="isax isax-clock me-1" />4 min ago
                              </span>
                              <div className="notification-action d-flex align-items-center float-end gap-2">
                                <Link
                                  to="#"
                                  className="notification-read rounded-circle bg-info"
                                  data-bs-toggle="tooltip"
                                  title=""
                                  data-bs-original-title="Make as Read"
                                  aria-label="Make as Read"
                                />
                                <button
                                  className="btn rounded-circle text-danger p-0"
                                  data-dismissible="#notification-3"
                                >
                                  <i className="isax isax-close-circle fs-12" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Item*/}
                      <div
                        className="dropdown-item notification-item py-2 text-wrap border-bottom"
                        id="notification-4"
                      >
                        <div className="d-flex">
                          <div className="flex-shrink-0">
                            <div className="avatar-sm me-2">
                              <span className="avatar-title bg-soft-warning text-warning fs-18 rounded-circle">
                                <i className="isax isax-message" />
                              </span>
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <p className="mb-0 text-wrap fs-14">
                              You have received{" "}
                              <span className="fw-semibold">20</span> new
                              messages in the conversation
                            </p>
                            <div className="d-flex justify-content-between align-items-center">
                              <span className="fs-12">
                                <i className="isax isax-clock me-1" />3 min ago
                              </span>
                              <div className="notification-action d-flex align-items-center float-end gap-2">
                                <Link
                                  to="#"
                                  className="notification-read rounded-circle bg-info"
                                  data-bs-toggle="tooltip"
                                  title=""
                                  data-bs-original-title="Make as Read"
                                  aria-label="Make as Read"
                                />
                                <button
                                  className="btn rounded-circle text-danger p-0"
                                  data-dismissible="#notification-4"
                                >
                                  <i className="isax isax-close-circle fs-12" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Item*/}
                      <div
                        className="dropdown-item notification-item py-2 text-wrap border-bottom"
                        id="notification-5"
                      >
                        <div className="d-flex">
                          <div className="me-2 position-relative flex-shrink-0">
                            <ImageWithBasePath
                              src="assets/img/profiles/avatar-17.jpg"
                              className="avatar-md rounded-circle"
                              alt=""
                            />
                          </div>
                          <div className="flex-grow-1">
                            <p className="mb-0 fw-semibold text-dark">
                              Charlotte Brown
                            </p>
                            <p className="mb-1 text-wrap fs-14">
                              New invoice generated{" "}
                              <span className="fw-semibold"> #INV00028</span>
                            </p>
                            <div className="mb-1">
                              <Link
                                className="badge bg-success p-2 py-1 me-1"
                                to="#"
                              >
                                Approve
                              </Link>
                              <Link className="badge bg-danger p-2 py-1" to="#">
                                Deny
                              </Link>
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                              <span className="fs-12">
                                <i className="isax isax-clock me-1" />
                                45 min ago
                              </span>
                              <div className="notification-action d-flex align-items-center float-end gap-2">
                                <Link
                                  to="#"
                                  className="notification-read rounded-circle bg-info"
                                  data-bs-toggle="tooltip"
                                  title=""
                                  data-bs-original-title="Make as Read"
                                  aria-label="Make as Read"
                                />
                                <button
                                  className="btn rounded-circle text-danger p-0"
                                  data-dismissible="#notification-5"
                                >
                                  <i className="isax isax-close-circle fs-12" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* View All*/}
                    <div className="p-2 rounded-bottom border-top text-center">
                      <Link
                        to={all_routes.notification}
                        className="text-center fw-medium fs-14 mb-0"
                      >
                        View All
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="me-2 theme-item">
                  {/* Dark Mode Toggle */}
                  <Link
                    to="#"
                    id="dark-mode-toggle"
                    className={`theme-toggle btn btn-menubar ${
                      themeSettings["data-bs-theme"] === "dark"
                        ? "activate"
                        : ""
                    }`}
                    onClick={() => handleUpdateTheme("data-bs-theme", "light")}
                  >
                    <i className="isax isax-sun-1" />
                  </Link>
                  {/* Light Mode Toggle */}
                  <Link
                    to="#"
                    id="light-mode-toggle"
                    className={`theme-toggle btn btn-menubar ${
                      themeSettings["data-bs-theme"] === "light"
                        ? "activate"
                        : ""
                    }`}
                    onClick={() => handleUpdateTheme("data-bs-theme", "dark")}
                  >
                    <i className="isax isax-moon" />
                  </Link>
                </div>
                {/* User Dropdown */}
                <div className="dropdown profile-dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle d-flex align-items-center"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <span className="avatar online">
                      <ImageWithBasePath
                        src="assets/img/profiles/avatar-01.jpg"
                        alt="Img"
                        className="img-fluid rounded-circle"
                      />
                    </span>
                  </Link>
                  <div className="dropdown-menu p-2">
                    <div className="d-flex align-items-center bg-light rounded-1 p-2 mb-2">
                      <span className="avatar avatar-lg me-2">
                        <ImageWithBasePath
                          src="assets/img/profiles/avatar-01.jpg"
                          alt="img"
                          className="rounded-circle"
                        />
                      </span>
                      <div>
                        <h6 className="fs-14 fw-medium mb-1">Jafna Cremson</h6>
                        <p className="fs-13">Administrator</p>
                      </div>
                    </div>
                    {/* Item*/}
                    <Link
                      className="dropdown-item d-flex align-items-center"
                      to={all_routes.accountSettings}
                    >
                      <i className="isax isax-profile-circle me-2" />
                      Profile Settings
                    </Link>
                    {/* Item*/}
                    <Link
                      className="dropdown-item d-flex align-items-center"
                      to={all_routes.inventoryReport}
                    >
                      <i className="isax isax-document-text me-2" />
                      Reports
                    </Link>
                    {/* Item*/}
                    <div className="form-check form-switch form-check-reverse d-flex align-items-center justify-content-between dropdown-item mb-0">
                      <label className="form-check-label" htmlFor="notify">
                        <i className="isax isax-notification me-2" />
                        Notifications
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="notify"
                      />
                    </div>
                    <hr className="dropdown-divider my-2" />
                    {/* Item*/}
                    <Link
                      className="dropdown-item logout d-flex align-items-center"
                      to={all_routes.login}
                    >
                      <i className="isax isax-logout me-2" />
                      Sign Out
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Mobile Menu */}
          <div className="dropdown mobile-user-menu profile-dropdown">
            <Link
              to="#"
              className="dropdown-toggle d-flex align-items-center"
              data-bs-toggle="dropdown"
              data-bs-auto-close="outside"
            >
              <span className="avatar avatar-md online">
                <ImageWithBasePath
                  src="assets/img/profiles/avatar-01.jpg"
                  alt="Img"
                  className="img-fluid rounded-circle"
                />
              </span>
            </Link>
            <div className="dropdown-menu p-2 mt-0">
              <Link
                className="dropdown-item d-flex align-items-center"
                to={all_routes.profile}
              >
                <i className="isax isax-profile-circle me-2" />
                Profile Settings
              </Link>
              <Link
                className="dropdown-item d-flex align-items-center"
                to={all_routes.inventoryReport}
              >
                <i className="isax isax-document-text me-2" />
                Reports
              </Link>
              <Link
                className="dropdown-item d-flex align-items-center"
                to={all_routes.accountSettings}
              >
                <i className="isax isax-setting me-2" />
                Settings
              </Link>
              <Link
                className="dropdown-item logout d-flex align-items-center"
                to={all_routes.login}
              >
                <i className="isax isax-logout me-2" />
                Signout
              </Link>
            </div>
          </div>
          {/* /Mobile Menu */}
        </div>
      </div>
      {/* Topbar End */}
    </>
  );
};


export default Header;



